import {
  CLEAR_ERROR,
  PERMISSION_ERROR,
  GENERAL_ERROR,
  IMPORT_ERROR,
  SAVE_TEMP_FILE_ERROR,
} from '../constants/ActionTypes'

/**
 * @typedef {import('../index').PltrAction} PltrAction
 * @typedef {import('../types/system').SystemError} SystemError
 */

/**
 * @type {SystemError}
 */
const INITIAL_STATE = {
  error: null,
  storeKey: null,
  action: null,
}

/**
 * @return {function(SystemError, PltrAction): SystemError}
 */
const errorReducer =
  (_dataRepairers) =>
  (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case PERMISSION_ERROR: {
        return {
          error: action.error,
          action: action.action,
          storeKey: action.storeKey,
        }
      }

      case GENERAL_ERROR:
        return {
          ...state,
          error: action.error,
        }

      case CLEAR_ERROR:
        return INITIAL_STATE

      case IMPORT_ERROR:
        return {
          ...state,
          error: action.error,
        }

      case SAVE_TEMP_FILE_ERROR: {
        return {
          ...state,
          error: action.error,
        }
      }

      default:
        return state
    }
  }

export default errorReducer
